import React from 'react';
import { Layout } from 'fronton-react';
import { HeaderSection, HeaderSectionText, SectionTitle } from 'common/components';
import { KitchenDesignPanel } from '../kitchen-design-panel';
import {
  headerImage,
  headerSection,
  headerSectionCards,
  headerSectionText,
  headerSectionTitle,
} from './new-kitchen-header-styles';
import { NewKitchenHeaderCard } from '../new-kitchen-header-card';
import { NEW_KITCHEN_CDN_PATH } from '../../new-kitchen-constants';

type NewKitchenHeaderProps = {
  isConsultationFormVisible: boolean;
  isRuRegion: boolean;
  signUpHref: string;
}

export const NewKitchenHeader: React.FC<NewKitchenHeaderProps> = (
  { isConsultationFormVisible, isRuRegion, signUpHref }
) => (
  <div className={headerSection}>
    <HeaderSection
      bgColor="#21282B"
      hasPattern={false}
      headerContent={(
        <HeaderSectionText className={headerSectionText}>
          <SectionTitle as="h1" className={headerSectionTitle} color="text-invert" size="extra">
            КУХНИ ПОД ВАШИ РАЗМЕРЫ БЫСТРО&nbsp;И&nbsp;ВЫГОДНО
          </SectionTitle>
        </HeaderSectionText>
      )}
      img={{
        alt: 'Изображение кухни',
        className: headerImage,
        ldSrcSet: `${NEW_KITCHEN_CDN_PATH}/header/header-ld.png/header-ld-01.png`,
        dSrcSet: `${NEW_KITCHEN_CDN_PATH}/header/header-d.png/header-d-01.png`,
        tSrcSet: `${NEW_KITCHEN_CDN_PATH}/header/header-t.png/header-t-01.png`,
        mSrcSet: `${NEW_KITCHEN_CDN_PATH}/header/header-m.png/header.png`,
      }}
      mediaType="image"
    />

    {isRuRegion && (
      <Layout className={headerSectionCards}>
        <NewKitchenHeaderCard signUpHref={signUpHref} />
      </Layout>
    )}

    <KitchenDesignPanel
      isConsultationFormVisible={isConsultationFormVisible}
      isRuRegion={isRuRegion}
      signUpHref={signUpHref}
      withWhiteBackground
    />
  </div>
);
